import PropTypes from 'prop-types';
import React from 'react';
import {
  PanelWrapper,
  PanelBody,
  PanelHeaderWrapper,
  PanelHeader,
  PanelSubHeader
} from './index.styles';

const PanelWithSubHeader = ({ props }) => {
  const {
    children,
    header,
    headerContent,
    subHeader,
    subHeaderContent,
    panelBodyStyles,
    panelWrapperStyles,
    errorState,
    completedState
  } = props || {};

  return (
    <PanelWrapper css={panelWrapperStyles}>
      <PanelHeaderWrapper>
        {(header || headerContent) &&
          <PanelHeader errorState={errorState} completedState={completedState}>
            {(typeof headerContent === 'string') ? <p>{headerContent}</p> : headerContent}
          </PanelHeader>
        }
        {(subHeader || subHeaderContent) &&
          <PanelSubHeader errorState={errorState} completedState={completedState}>
            {(typeof subHeaderContent === 'string') ? <p>{subHeaderContent}</p> : subHeaderContent}
          </PanelSubHeader>
        }
      </PanelHeaderWrapper>
      <PanelBody css={panelBodyStyles}>{children}</PanelBody>
    </PanelWrapper>
  );
};

PanelWithSubHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  header: PropTypes.bool,
  headerContent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  subHeader: PropTypes.bool,
  subHeaderContent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  panelBodyStyles: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  panelWrapperStyles: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  errorState: PropTypes.bool,
  completedState: PropTypes.bool
};

PanelWithSubHeader.defaultProps = {
  children: null,
  header: false,
  headerContent: null,
  subHeader: false,
  subHeaderContent: null,
  panelBodyStyles: null,
  panelWrapperStyles: null,
  errorState: false,
  completedState: false
};

export default PanelWithSubHeader;
